var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('PublicHeader',{attrs:{"totalName":_vm.$t('public').xq}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.info)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }